import { keyframes, styled } from 'styled-components';
import { ReactComponent as ChevronLeft } from '../../assets/icons/chevron-left.svg';

export const Button = styled.button`
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  user-select: none;
  justify-content: center;

  min-width: 17rem;
  border: none;
  padding: 0rem 2rem;
  width: fit-content;
  height: 5rem;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  border-radius: 3rem;
  background: #6868ac;
  box-shadow: 0px 12px 24px -6px rgba(81, 81, 145, 0.46);

  color: #fff;
  text-align: center;
  font-family: 'Avenir-Medium';
  font-size: 2rem;
  letter-spacing: 0.1px;

  &:hover {
    background: ${({ disabled }) => (disabled ? null : '#484888')};
  }

  &:active {
    ${({ disabled }) =>
      disabled
        ? null
        : `
    box-shadow: 0px 2px 8px -5px rgb(128, 128, 128);
    transition: all 0.1s ease-in;
    transform: scale(0.95);
  `};
  }
  @media (max-width: 450px) {
    font-size: 16px;
    height: 45px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  width: 100%;
  margin-bottom: 8rem;
`;

export const Subtitle = styled.span`
  font-family: 'Avenir-Medium';
  font-size: 2.2rem;
  letter-spacing: -0.178px;
  text-transform: lowercase;
`;

export const Products = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
`;

export const BackContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: 0.5rem;
  position: absolute;
  right: 1rem;
  top: 1rem;
  font-size: 2rem;
  cursor: pointer;
  align-content: center;
  user-select: none;
  font-family: 'Avenir-Heavy';
  justify-content: center;
  padding-top: 0.15rem;
  display: flex;
  width: 3rem;
  height: 3rem;
  background-color: white;
  border-radius: 50%;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
`;

export const Chevron = styled(ChevronLeft)`
  cursor: pointer;
`;
const fadeIn = keyframes`
  from {
    opacity: 0;

  }
  to {
    opacity: 1;

  }
`;

export const Product = styled.div`
  display: flex;
  flex-direction: row;
  gap: 7rem;
  max-width: 120rem;
  width: 100%;
  flex-wrap: wrap;
  @media (max-width: 875px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media (max-width: 875px) {
    align-items: center;
    justify-content: center;
  }
`;

export const Label = styled.span`
  font-size: 1.8rem;
  font-family: 'Avenir-Medium';
  margin-bottom: 1rem;
  @media (max-width: 875px) {
    text-align: center;
  }
`;

export const Name = styled.span`
  font-size: 1.8rem;
  font-family: 'Avenir-Heavy';
  @media (max-width: 875px) {
    text-align: center;
  }
`;

export const Price = styled(Label)`
  margin-bottom: 0rem;
`;
export const Quantity = styled(Price)``;

export const ProductImg = styled.img`
  width: 23.5rem;
  height: 23.5rem;
  object-fit: cover;
`;
export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const SectionTitle = styled.div`
  color: #454584;
  font-family: 'Avenir-Medium';
  font-size: 22px;
  font-weight: 500;
  letter-spacing: -0.178px;
  padding-bottom: 20px;
`;

export const DeliveryDetailsSection = styled.div`
  margin-top: 20px;
`;

export const ContactMapContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ContactDetailsContainer = styled.div`
  flex: 1;
  min-width: 200px;
`;

export const ContactItem = styled.div`
  color: #000;
  font-family: 'Avenir-Medium';
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.178px;
`;

export const ContactValue = styled.div`
  color: #000;
  font-family: 'Avenir-Medium';
  font-size: 22px;
  padding-bottom: 10px;
`;
export const ContactPhone = styled.span`
  color: #000;
  font-family: 'Avenir';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.178px;
`;

export const MapContainer = styled.div`
  flex: 1;
  min-width: 300px;
`;

export const LocationName = styled.div`
  max-width: 400px;
  color: #000;
  font-family: 'Avenir-Medium';
  font-size: 18px;
  font-weight: 400;
  line-height: 1.4;
  white-space: normal;
  word-break: break-word;
`;

export const AddressDetails = styled.div`
  margin-top: 20px;
  padding: 15px;
`;
